module.exports = __webpack_public_path__ + "static/img/index-notice.23cfe6d4.png";